
import User, { Role } from "@/model/User";
import { PropType, defineComponent } from "vue";
import { getState as getNavigationState } from "@/pinia/NavigationState";
import * as Lang from "@/i18n/lang";
import { getCommunicationsState } from "@/pinia/communications/CommunicationsState";
import CommunicationStatus from "@/components/communication/CommunicationStatus.vue";
import { getCommunicationStatsState } from "@/pinia/communications/CommunicationStatsState";
import { getState } from "@/pinia/AppState";
import Training from "@/model/Trainings/Training";
import { getTrainingsState } from "@/pinia/trainings/TrainingsState";
import { getTrainingState } from "@/pinia/trainings/TrainingState";
import { getTrainingStatsState } from "@/pinia/trainings/TrainingStatsState";
import Database from "@/model/Database";
export default defineComponent({
  components: {},
  data() {
    return {
      Role: Role,
      myRole: getState().userData!.role,
      Lang: Lang,
      state: getTrainingsState(),
    };
  },
  props: {
    database: {
      type: Database,
      required: false,
      nullable: true,
    },
  },
  methods: {
    viewTrainingStats(training: Training) {
      getTrainingStatsState().set(training);
      getNavigationState().navigate("trainingStats");
    },
    editTraining(training: Training) {
      getTrainingState().set(this.database, training);
      getNavigationState().navigate("training");
    },
    canEdit(training: Training) {
      if (this.myRole == Role.Customer) {
        return training.type == "store";
      }

      if (this.myRole == Role.Distributor) {
        return training.type == "distributor" || training.type == "database";
      }

      if (this.myRole == Role.Admin) {
        return true;
      }
      if (this.myRole == Role.Manager) {
        return training.type == "database";
      }
      return true;
    },
    getTrainingSubtitle(training: Training) {

      switch (training.type) {
        case "secureat":
          return "Formation globale";
        case "distributor":
          return "Formation distributeur";
        case "database":
          return "Formation base de donnée";
        case "store":
          return "Formation établissement";

      }

      return "?"
    }
  },
});
